import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import Typography from '@mui/material/Typography';
import { DEFAULT_BACKGROUND_SUBTLE_HIGHLIGHT_COLOR } from '../styles/colors';
export const HeaderPanelItem = ({ title }) => {
    return (_jsx("div", { css: css `
        margin: 20px 0 0 0;
      `, children: _jsx(Typography, { css: css `
          font-weight: bold;
          padding: 15px;
          background-color: ${DEFAULT_BACKGROUND_SUBTLE_HIGHLIGHT_COLOR};
        `, component: 'div', variant: 'h6', children: title }) }));
};
